/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { CLOSE_CLICKED, ERROR_OCCURRED, MEDIA_RECORDER_INITIALIZED, SAVE_CLICKED, STARTOVER_CLICKED, UNMOUNT_CLEAN_UP } from '../../constants/ActionTypes';
export default function recordingNavigationWarningMiddleware() {
  const handler = event => {
    event.preventDefault();
    // eslint-disable-next-line no-param-reassign
    return event.returnValue = '';
  };
  return next => action => {
    switch (action.type) {
      case MEDIA_RECORDER_INITIALIZED:
        window.addEventListener('beforeunload', handler, {
          capture: true
        });
        break;
      case ERROR_OCCURRED:
        if (action.critical) {
          window.removeEventListener('beforeunload', handler, {
            capture: true
          });
        }
        break;
      case STARTOVER_CLICKED:
      case SAVE_CLICKED:
      case CLOSE_CLICKED:
      case UNMOUNT_CLEAN_UP:
        window.removeEventListener('beforeunload', handler, {
          capture: true
        });
        break;
    }
    return next(action);
  };
}